import { getTableTotalizers } from '@/features/EngagementReport/services';
export const fetchTotalizers = ({ preset, limit, page, orderBy, query, campaignId, storeId, sellerId, cluster, }) => getTableTotalizers({
    preset,
    limit,
    page,
    orderBy,
    query,
    campaignId,
    storeId,
    sellerId,
    cluster,
}).then(response => formatResponse(response?.data));
const formatResponse = (response) => ({
    success: response?.success,
    errors: response?.errors,
    data: response?.data,
});
